// extracted by mini-css-extract-plugin
export default {"cl_banner":"collectionlayout_cl_banner__u+2nM"};